module.exports = __webpack_public_path__ + "img/Manihot_esculenta.c8fed9ca.jpg";